/** Which vendor supplies the criminal + eviction reports of an application; null = credit only (co-signer). */
export enum BackgroundRecordsProvider {
  TRANS_UNION = 'TransUnion',
  RENT_PREP = 'RentPrep',
}
